module.exports = __webpack_public_path__ + "img/photoshop.e21524ff.svg";